export default __webpack_public_path__ + "static/media/ic_xvs_40.2f384913.svg";